module.exports = __webpack_public_path__ + "static/media/fatcat1.ab86e57a.png";